export default __webpack_public_path__ + "static/media/rascalArdenweald.3477b5e0.jpg";